import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { Button, Footer, Icon, Text } from '@shared/widgets';
import LogoIcon from '@assets/icons/logo/logo-small.svg';
import LogoVcfcIcon from '@assets/icons/logo/logo-vcfc-small.svg';
import ChevronIcon from '@assets/icons/chevron.svg';
import StarIcon from '@assets/icons/star.svg';

export interface SuccessProps {
  title?: string;
  header?: string;
  message?: string;
  blank?: boolean;
  logo?: boolean;
}

export const SuccessPage = (props: SuccessProps) => {
  const {
    title = 'Registration successful!',
    header = 'Registration successful!',
    message = 'You can now log in',
    blank = true,
    logo = true,
  } = props;

  const { back } = useRouteHook();

  useEffect(() => {
    document.title = title;
  }, []);

  return (
    <>
      <div className='grow flex flex-col relative'>
        <div className='flex flex-col py-24 px-0 flex-auto relative overflow-hidden items-center flex-nowrap justify-center'>
          <div className='absolute left-0 top-[3%] w-full min-h-20 flex'>
            <div className={clsx('container', !blank && 'container_wide')}>
              {logo ? (
                <NavLink className='inline-block align-top' to={RoutePaths.dashboard.onNavigate()}>
                  {PaletteUtils.isInsigniaPalette && <LogoIcon />}
                  {PaletteUtils.isVcfcPalette && <LogoVcfcIcon />}
                </NavLink>
              ) : (
                <div className='inline-flex items-center gap-1 cursor-pointer' onClick={back}>
                  <ChevronIcon />
                  <Text size='sm'>Go Back</Text>
                </div>
              )}
            </div>
          </div>
          <div className='w-full max-w-[1290px] px-8 mx-auto'>
            <div className={clsx(blank ? 'my-0 mx-auto' : 'w-20')}>
              <div className={clsx('mb-12', blank && 'text-center')}>
                <Text className='font-[Prata] text-6xl mb-6' weight='medium' size='6xl'>
                  {header}
                </Text>
                {message && <Text>{message}</Text>}
              </div>
              <Button className='w-[270px] mx-auto' color='primary' onClick={() => document.location.replace(`${process.env.LOGIN_URL}`)}>
                Log in
              </Button>
            </div>
          </div>
          <Icon icon={<StarIcon />} className='absolute left-[3%] top-[45%' color='primary' />
          <Icon icon={<StarIcon />} className='absolute left-[19%] top-[55%]' color='primary' />
          <Icon icon={<StarIcon />} className='absolute left-[75%] top-[22%]' color='primary' />
        </div>
      </div>
      <Footer />
    </>
  );
};
